const TextoPiePgina = ({ elementosweb, lang }) => {

    if (!elementosweb.pie_pagina || !elementosweb.pie_pagina[lang]) return null;

    return (
        <section className="c-presentation c-presentation--light o-container text-center hc-piepagina">
            <div className="c-presentation__content">
                <p>{elementosweb.pie_pagina[lang]}</p>
            </div>
        </section>
    );
};

export default TextoPiePgina;
